import { observer } from 'mobx-react-lite'
import { Platform, StyleSheet } from 'react-native'
import { View } from 'react-native'
import { useStore } from '../../../../../models'
import { DealTheFlopStep } from '../../../../../models/game/walkthrough/deal-the-flop'
import { RaiseOrFoldStep } from '../../../../../models/game/walkthrough/raise-or-fold'
import { palette } from '../../../../../theme/palette'
import { Chip } from './Chip'
import { DS } from '../../../../../design-system'
import { BottomSheetView } from '@gorhom/bottom-sheet'

export interface WalkthroughProps {
  correct: boolean
  onNext: () => void
  onViewTableOrResponse: () => void
}

export const Walkthrough = observer(({ correct, onNext, onViewTableOrResponse }: WalkthroughProps) => {
  const {
    game: { currentStep, walkthroughType, isPreviousToLastStep, isResponseVisible }
  } = useStore()
  if (!(currentStep && walkthroughType && ['RaiseOrFold', 'DealTheFlop'].includes(walkthroughType))) return null

  const step = currentStep as RaiseOrFoldStep | DealTheFlopStep

  const buttonText = walkthroughType === 'RaiseOrFold' ? 'Next' : isPreviousToLastStep ? 'Finish' : 'Deal Again'
  const buttonResponseText = isResponseVisible ? 'View Table' : 'View Response'

  return (
    <BottomSheetView style={Platform.OS !== 'web' ? { flex: 1 } : {}}>
      <View style={[styles.container, { justifyContent: isResponseVisible ? 'space-around' : undefined }]}>
        {isResponseVisible ? (
          <DS.Frame gap="16">
            <Chip correct={correct} />
            <View style={styles.textContainer}>
              <DS.Text variant={'Heading 3/Medium'}>{step.answer.title}</DS.Text>
              <DS.Text variant={'Body Medium/Regular'}>{step.answer.description}</DS.Text>
            </View>
          </DS.Frame>
        ) : null}
        <DS.Frame gap="8">
          <DS.Button variant="Large/Primary" type="On Light" onPress={onNext}>
            {buttonText}
          </DS.Button>
          <DS.Button variant="Large/Secondary" type="On Dark" onPress={onViewTableOrResponse}>
            {buttonResponseText}
          </DS.Button>
        </DS.Frame>
      </View>
    </BottomSheetView>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: palette.cream,
    gap: DS.spacing[16],
    paddingHorizontal: 24,
    paddingBottom: DS.spacing[16]
  },
  textContainer: {
    gap: DS.spacing[8]
  }
})
